import React from 'react'
import { Grid, Container, ThemeProvider } from '@deseretbook/react-ui'
import { useMediaQuery } from '@deseretbook/react-utils'
import PropTypes from 'prop-types'
import { AlgoliaContainer, Hits, Pagination, SidebarContainer } from '../../core/search'

/**
 * Search container for product Pages
 *
 * @param {string} taxon - The current page taxon
 * @param {string} taxonomy - The current page taxonomy
 *
 * @returns {function} - Product search container
 */
const ProductSearchContainer = ({ taxon, taxonomy }) => {
  // For when the content reaches its mobile breakpoint
  const isMediumOrSmaller = useMediaQuery({ maxWidth: 1015 })

  const gridColumns = [20, Grid.fr(3)]

  if (isMediumOrSmaller) {
    gridColumns.shift()
  }

  return (
    <ThemeProvider>
      <AlgoliaContainer facets={{ taxon, taxonomy }}>
        <Container>
          <Grid columns={gridColumns} columnGap={6} rowGap={1}>
            <Grid.Item>
              <SidebarContainer />
            </Grid.Item>
            <Grid.Item>
              <Hits />
              <Pagination />
            </Grid.Item>
          </Grid>
        </Container>
      </AlgoliaContainer>
    </ThemeProvider>
  )
}

ProductSearchContainer.propTypes = {
  taxon: PropTypes.string,
  taxonomy: PropTypes.string,
}

export default ProductSearchContainer
